export default __webpack_public_path__ + "static/cruiselines-vrc-ship-7-23406803802a9047648a24e7568d2fd3.jpg";